import { render, staticRenderFns } from "./contentLearnerCreateImport.vue?vue&type=template&id=816e9b0c&"
import script from "./contentLearnerCreateImport.vue?vue&type=script&lang=js&"
export * from "./contentLearnerCreateImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports